import React, { useRef } from 'react'
import SlidingPane from "react-sliding-pane";
import Tooltip from "@tippyjs/react";
import "react-toastify/dist/ReactToastify.css";
import "tippy.js/dist/tippy.css";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import { getTrans as t } from "../../../Localization/translations";

const AddVendor = ({state4,setState4,handleSubmit4,handlepartyvendor,form4,party_typevendor,setParty_typeVendor,
    customer_typevendor,register4,handleshowhidevendor,errors4,customer_namevendor,setCustomer_nameVendor,vendoraddress_line_1,setVendorAddress_line_1,
    setVendorAddress_line_2,vendoraddress_line_2,vendorcountryid,handlecountryVendor,vendor_country_name,venderstateaddressId,handlestateVender,
    vendor_state_name,vendorcity,setVendorCity,vendorzip_code,setVendorZip_code,checkBtn4
}) => {
  return (
    <SlidingPane
            className="some-custom-class sidepanebar"
            isOpen={state4.isPaneOpen}
            title="Add Vendor"
            subtitle=""
            onRequestClose={() => {
              setState4({ isPaneOpen: false });
            }}
          >
    
            <Form
              role="form text-left"
              onSubmit={handleSubmit4(handlepartyvendor)}
              ref={form4}
              key={4}
              action="."
              method="POST"
              id="addReceiptForm"
            >
              {
                <>
                  <div className="row">
                    <div className="col-md-6">
                      <label className="col-form-label required">
                        {t("Party Type")}{" "}
                        <Tooltip content={t("PartyType_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <div className="form-group row">
                        <div
                          className="form-check"
                          style={{ width: "25%", paddingLeft: "3.0em" }}
                        >
                          <input
                            className="form-check-input"
                            checked={party_typevendor === "Vendor" ? true : false}
                            value="Vendor"
                            type="radio"
                            name="vendor"
                            id="flexRadioDefault2"
                            onChange={(e) => setParty_typeVendor(e.target.value)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexRadioDefault2"
                          >
                            Vendor
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <label className="col-form-label required">
                      {t("Entity Type")}{" "}
                      <Tooltip content={t("EntityType_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    <div className="form-group row">
                      <div
                        className="form-check"
                        style={{ width: "25%", paddingLeft: "2.73em" }}
                      >
                        <input
                          className="form-check-input"
                          checked={
                            customer_typevendor === "Person" ? true : false
                          }
                          value="Person"
                          type="radio"
                          name="person"
                          id="id_customer_type"
                          {...register4("customer_type", {
                            onChange: (e) => {
                              handleshowhidevendor(e);
                            },
                            required: true,
                          })}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault1"
                        >
                          Person
                        </label>
                      </div>
                      <div
                        className="form-check"
                        style={{ width: "25%", paddingLeft: "4.73em" }}
                      >
                        <input
                          className="form-check-input"
                          checked={
                            customer_typevendor === "Organization" ? true : false
                          }
                          value="Organization"
                          type="radio"
                          name="organization"
                          id="id_customer_type"
                          {...register4("customer_type", {
                            onChange: (e) => {
                              handleshowhidevendor(e);
                            },
                            required: true,
                          })}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault1"
                        >
                          Organization
                        </label>
                      </div>
                    </div>
    
                    <div className="invalid-feedback">
                      {errors4.customer_type?.type === "required" &&
                        "Entity Type  is required"}
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-md-12">
                      <label className="col-form-label required">
                        {t("Party Name")}{" "}
                        <Tooltip content={t("PartyName_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <input
                        placeholder={t("Party Name")}
                        className="form-control"
                        type="text"
                        value={customer_namevendor}
                        name="customer_name"
                        maxLength="200"
                        id="id_customer_name"
                        {...register4("customer_name", {
                          onChange: (e) => {
                            setCustomer_nameVendor(e.target.value);
                          },
                          required: true,
                        })}
                      />
                      <div className="invalid-feedback">
                        {errors4.customer_name?.type === "required" &&
                          "Party Name  is required"}
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-6">
                        <label className="col-form-label required">
                          {t("Address Line 1")}{" "}
                          <Tooltip content={t("Address_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("Address Line 1")}
                          className="form-control"
                          type="text"
                          name="address_line_1"
                          maxLength="200"
                          id="id_address_line_1"
                          value={vendoraddress_line_1}
                          {...register4("address_line_1", {
                            onChange: (e) => {
                              setVendorAddress_line_1(e.target.value);
                            },
                            required: true,
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors4.address_line_1?.type === "required" &&
                            "Address is required"}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label className="col-form-label">
                          {t("Address Line 2")}{" "}
                          <Tooltip content={t("Address2_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("Address Line 2")}
                          className="form-control"
                          type="text"
                          onChange={(e) =>
                            setVendorAddress_line_2(e.target.value)
                          }
                          name="address_line_2"
                          maxLength="200"
                          id="id_address_line_2"
                          value={vendoraddress_line_2}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-6">
                        <label className="col-form-label required">
                          {t("Country")}{" "}
                          <Tooltip content={t("Country_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <select
                          type="text"
                          className="form-control"
                          value={vendorcountryid}
                          name="country"
                          {...register4("country", { onChange: (e) => { handlecountryVendor(e) }, required: true })}
                        >
                          <option value="">---{t("Select Country")}---</option>
                          {
                            vendor_country_name.map((country, i) =>
                            (
                              <option key={i} value={country.id} >{country.name}</option>
                            ))
                          }
                        </select>
                        <div className="invalid-feedback">
                          {errors4.country?.type === "required" &&
                            "Country is required"}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label className="col-form-label required">
                          {t("State")}{" "}
                          <Tooltip content={t("State_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <select
                          value={venderstateaddressId}
                          className="form-control"
                          name="state"
                          {...register4("state", { onChange: (e) => { handlestateVender(e) }, required: true })}
                        >
                          <option value="">---{t("Select State")}---</option>
                          {
                            vendor_state_name.map((resst, i) => (
                              <option key={i} value={resst.id} >{resst.name}</option>
                            ))
                          }
                        </select>
                        <div className="invalid-feedback">
                          {errors4.state?.type === "required" &&
                            "State is required"}
                        </div>
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-6">
                        <label className="col-form-label required">
                          {t("City")}{" "}
                          <Tooltip content={t("City_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("City")}
                          className="form-control"
                          type="text"
                          name="city"
                          maxLength="100"
                          id="id_city"
                          value={vendorcity}
                          {...register4("city", {
                            onChange: (e) => {
                              setVendorCity(e.target.value);
                            },
                            required: true,
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors4.city?.type === "required" &&
                            "City is required"}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label className="col-form-label required">
                          {t("Zip Code")}{" "}
                          <Tooltip content={t("ZipCode_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("Zip Code")}
                          className="form-control"
                          type="text"
                          name="zip_code"
                          maxLength="30"
                          id="id_zip_code"
                          value={vendorzip_code}
                          {...register4("zip_code", {
                            onChange: (e) => {
                              setVendorZip_code(e.target.value);
                            },
                            required: true,
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors4.zip_code?.type === "required" &&
                            "Zip Code is required"}
                        </div>
                      </div>
    
                    </div>
                  </div>
                  <button
                    type="submit"
                    className="border-0 btn btn-primary btn-gradient-primary btn-sm"
                  >
                    {t("Save")}
                  </button>
                  &nbsp;&nbsp;
                </>
              }
              <CheckButton style={{ display: "none" }} ref={checkBtn4} />
            </Form>
          </SlidingPane>
  )
}

export default AddVendor